// extracted by mini-css-extract-plugin
export default {"vFeed":"index_vFeed_X0MB7","vComment":"index_vComment_qzVBS","vDingCai":"index_vDingCai_0Fuqj","vDing":"index_vDing_Lv9qU","candle":"index_candle_qZ6ys","pray":"index_pray_yP-fj"};